<template>
  <div>
    <h3 style="display: none">I'm empty.</h3>
  </div>
</template>
<script>
const DEFAULT_HOME = "checkout";

export default {
  name: "Index",
  mounted: function () {
    console.log("Route is " + this.$route.fullPath);
    console.log("Host name is " + window.location.host);
    var entryPoint = DEFAULT_HOME;
    switch (window.location.host) {
      case "center.dropsmart.io":
        entryPoint = "Checkout";
        break;
      case "id.dropsmart.io":
      case "my.dropsmart.io":
        entryPoint = "Login";
        break;
      default:
        break;
    }
    let q = this.$route.query;
    var home = entryPoint;
    if (q && "p" in q) {
      home = q["p"];
      delete q["p"];
    }
    let r = { path: home, query: q };
    this.$router.push(r);
  },
};
</script>
